import TableFragment from "./TableFragment";

export default class Sheet {
  /**
   * @param {string} title
   * @param {TableFragment} frag
   */
  constructor(title, frag) {
    this.title = title;
    this.frag = frag;
  }
}
